import PraisoServices from "./PraisoServices";
import { getToken, getAPIResponse, setAPIResponse } from "./LocalStorageService";
import { APIURL } from "../config/app-globals.enum";

// Score card Api
export const GetScoreCardAPI = async (params) => {
  const ApiUrl = APIURL.DASHBOARD_COMPUTE_API;
  let url = ApiUrl;

  let payload:any = {};
  if (params.impersonationid) {
    payload.impersonationId = params.impersonationid;
    url = `${url}?${params.impersonationid}`;
  }
  const token = getToken();
  try {
    const data = getAPIResponse(url);
    if (data !== null) {
      return data;
    }
    const response = await PraisoServices(
      ApiUrl,
      "post",
      { ...payload },
      {
      },
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      setAPIResponse(url, response);
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const GetDriverScoreStatisticsData = async (params) => {
  const data = await GetScoreCardAPI(params);
  return data;
  // if (data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
  //   return data;
  // } else {
  //   return data
  // }
};

